import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=ca6d001a&scoped=true&"
import script from "./js/index.js?vue&type=script&lang=js&"
export * from "./js/index.js?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=ca6d001a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6d001a",
  null
  
)

export default component.exports